import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { session } from '@/shared/session/session';

import type { ScheduleErrorCopy } from '../api/schedule-errors';

/**
 * Turns schedule error copy into a sentence, naming `{{store}}` from `storeNames` (a schedule's
 * own targets, which include stores the member cannot open) or the session's stores.
 */
export function useScheduleCopy(storeNames?: ReadonlyMap<string, string>) {
  const { t } = useTranslation('schedules');
  const { me } = session.useSession();
  const stores = me?.stores;
  return useCallback(
    (copy: ScheduleErrorCopy): string => {
      const store = copy.storeId
        ? (storeNames?.get(copy.storeId) ??
          stores?.find((s) => s.id === copy.storeId)?.name ??
          t('errors.aStore'))
        : t('errors.aStore');
      return t(copy.key, { ...copy.values, store });
    },
    [storeNames, stores, t],
  );
}
